function Loading() {
  return (
    <div class="load-parent">
      <div class="circle animate delay-1"></div>
      <div class="circle animate delay-2"></div>
      <div class="circle animate delay-3"></div>
    </div>
  );
}

export default Loading;